import { render } from "./BaseBackground.vue?vue&type=template&id=34fd6835&scoped=true"
import script from "./BaseBackground.vue?vue&type=script&lang=js"
export * from "./BaseBackground.vue?vue&type=script&lang=js"

import "./BaseBackground.vue?vue&type=style&index=0&id=34fd6835&scoped=true&lang=css"

import exportComponent from "/builds/sats/careers-application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34fd6835"]])

export default __exports__